import { reset } from 'communicator/store';

export default async function sessionExpired() {
  reset();
  return {};
}
